import React, { createRef, useEffect, useMemo, useState } from "react";
import Slider from "react-slick";
import PrevArrow from "../../LearningPaths/PrevArrow";
import NextArrow from "../../LearningPaths/NextArrow";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { formatMinutes, getDateTime, SessionKeys } from "../../../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import Accordion from "react-bootstrap/Accordion";
import {
  getCrsReportManagers,
  getCrsReportManagersClear,
  getCrsReportOffices,
  getCrsReportOfficesClear,
  getCrsReportRea,
  getCrsReportReaClear,
  getCrsReportStats,
  getCrsReportStatsClear,
  getCrsReportTrend,
  getCrsReportTrendClear,
  getCrsReportTrendOfSingle,
  getCrsReportTrendOfSingleClear,
  getSavedFilterDataById,
  getSavedFilterDataResponseClearById,
} from "../../../redux/reports/actions";
import _ from "lodash";
import ProgressReportTableComponent from "../progressReport/ProgressReportTableComponent";
import RealEstateAgentsReportSection from "./RealEstateAgentsReportSection";
import Loader from "../../Loader/Loader";
import PiechartProgressReport from "../New Progress Report/PiechartProgressReport";
import {
  getAnyTotalReportClear,
  getProfileCompletionReport,
  getProfileCompletionReportClear,
} from "../../../redux/reports/actions";

import { useLocation, useNavigate } from "react-router-dom";

import ManagerReportCrs from "../New Progress Report/ManagerReportCrs";
import OfficesReportSection from "../New Progress Report/OfficesReportSection";

import moment from "moment";
import ReportGraphComponent from "../layout/ReportGraphComponent";
import StaticUtils from "../../../utils/StaticUtils";
import * as XLSX from "xlsx";
import { formatREACardData } from "../../../utils/reportUtils";
import REACardAreaSection from "../layout/REACardAreaSection";
import ReportFiltersComponent from "../layout/ReportFiltersComponent";
import ReportExportButtonComponent from "../layout/ReportExportButtonComponent";
import ReportHeaderComponent from "../layout/ReportHeaderComponent";
import CONFIG from "../../../utils/config";
import { isAndroid, isIOS } from "react-device-detect";
import API_LIST from "../../../utils/apiList";
import axios from "axios";
import ConfirmModal from "../../modal/ConfirmModal";
import { useTranslation } from "react-i18next";
const ComplianceReportSection = (props) => {
  const { isMobile } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const filterId = params.get("filters_id");
  const backbutton = params.get("backbutton");
  const isCompliance = params.get("isCompliance");
  const idFrom = params.get("id");
  const from = params.get("from");

  const d = new Date();
  let year = d.getFullYear();

  const rea_ids = [];
  const manager_ids = [];
  const office_ids = [];
  const courseList = [];
  const providerList = [];

  const authBroker = useSelector((state) => state.auth.authBroker);
  const authIframeBroker = useSelector((state) => state.auth.authIframeBroker);
  const overAllDataRes = useSelector((state) => state.report.overallData);
  const overAllSummaryGraphRes = useSelector(
    (state) => state.report.overallSummaryCrsGraph
  );
  const overAllSummaryCrsRes = useSelector(
    (state) => state.report.overallSummaryCrsData
  );
  const getSavedFiltersDataResponseById = useSelector(
    (state) => state.report.savedFilterDataById
  );
  const crsTableRes = useSelector((state) => state.report?.lpTable);
  const crsReaRes = useSelector((state) => state.report?.crsReportRea);
  const crsTrendRes = useSelector((state) => state.report?.crsReportTrend);
  const crsReportTrendOfSingleRes = useSelector(
    (state) => state.report?.crsReportTrendOfSingle
  );
  const crsStatsRes = useSelector((state) => state.report?.crsReportStats);
  const profileReportRes = useSelector((state) => state.report.profileReport);
  const anyTotalReportRes = useSelector(
    (state) => state.report?.anyTotalReport
  );
  const crsCompletionTrendRes = useSelector(
    (state) => state.report.crsCompletionTrend
  );
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const userDetailIframe = useSelector((state) => state.user.userDetailIframe);
  const crsManagersRes = useSelector(
    (state) => state.report?.crsReportManagers
  );
  const crsOfficesRes = useSelector((state) => state.report?.crsReportOffices);

  const [confirmModal, setConfirmModal] = useState(false);
  const [savedFiltersDataById, setSavedFiltersDataById] = useState("");
  const [overSummaryCrsData, setOverSummaryCrsData] = useState([]);
  const [reaList, setReaList] = useState([]);
  const [overCrsGraphData, setOverCrsGraphData] = useState([]);
  const [crsCompltTrendData, setCrsCompltTrendData] = useState([]);
  const [overAllData, setOverAllData] = useState([]);
  const [overAllOfficesData, setOverAllOfficesData] = useState([]);
  const [overAllManagersData, setOverAllManagersData] = useState([]);
  const [overAllLearningPoints, setOverAllLearningPoints] = useState([]);
  const [overAllLearningHours, setOverAllLearningHours] = useState([]);
  const [OverAllStatsData, setOverAllStatsData] = useState([]);
  const [isView, setIsView] = useState("table");
  const [type, setType] = useState("pie");
  const [canShow, setCanShow] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);
  const [limitStatus, setLimitStatus] = useState("");
  const [loadSpin, setLoadSpin] = useState(true);
  const [totalRea, setTotalRea] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [imgLoader, setImgLoader] = useState(true);
  const [crsCompltTrendValues, setCrsCompltTrendValues] = useState([]);
  const [crsCompltTrendValuesOfSingle, setCrsCompltTrendValuesOfSingle] =
    useState([]);
  const [trendFilterCourses, setTrendFilterCourses] = useState([]);
  const [trendFilterCoursesOfSingle, setTrendFilterCoursesOfSingle] = useState(
    []
  );
  const [statusFilterData] = useState([
    "Completed",
    "Inprogress",
    "OverDue",
    "Yet to start",
  ]);
  const [profileReports, setProfileReports] = useState(null);
  const [profileReportsFilter, setProfileReportsFilter] = useState([]);
  const [realEstateAgent, setRealEstateAgent] = useState([]);
  const [filterYearData, setFilterYearData] = useState([]);
  const [filterYearDataOfSingle, setFilterYearDataOfSingle] = useState([]);
  const [legendOfSingle, setLegendOfSingle] = useState([]);
  const [seriesOfSingle, setSeriesOfSingle] = useState([]);
  const [legendOfAll, setLegendOfAll] = useState([]);
  const [seriesOfAll, setSeriesOfAll] = useState([]);
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [totalManagers, setTotalManagers] = useState([]);
  const [trendYear, setTrendYear] = useState(year);
  const [currentPage, setCurrentPage] = useState(1);
  const [limitData, setLimitData] = useState();
  const [totalRecord, setTotalRecord] = useState(0);
  const [legends, setLegends] = useState([]);
  const [series, setSeries] = useState([]);
  let PageSize = 20;
  const [counter, setCounter] = useState(1);
  const FILTER_BY = [
    { id: 0, value: "Select" },
    { id: 1, value: "Learning Points" },
    { id: 2, value: "Progress" },
    { id: 3, value: "Learning Hours" },
  ];
  const [filterBy, setFilterBy] = useState(FILTER_BY[0].value);
  const [actualCoursesList, setActualCoursesList] = useState([]);
  const [loaderChart, setLoaderChart] = useState(true);
  const [trendLoaderChart, setTrendLoaderChart] = useState(false);
  const [coursesList, setCoursesList] = useState([]);
  const [increment, setIncrement] = useState(1);
  const [selectedRea] = useState(location?.state?.selectedTeamMatesList);
  const [selectedCrsList] = useState(location?.state?.selectedCourseList);
  const [selectedProviderList, setSelectedProviderList] = useState([]);
  const [selectedCourseList, setSelectedCourseList] = useState([]);
  const [selectedManagerCoachList, setSelectedManagerCoachList] = useState([]);
  const [selectedTeamMatesList, setSelectedTeamMatesList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([
    "completed",
    "in-progress",
    "overdue",
    "not-started",
  ]);
  const [selectedAssignment, setSelectedAssignment] = useState([
    "self",
    "manager",
    "broker_admin",
    // "api",
  ]);
  const [checkApiAssign, setCheckApiAssign] = useState(true);
  const [checkSelfAssign, setCheckSelfAssign] = useState(true);
  const [checkManagerAssign, setCheckManagerAssign] = useState(true);
  const [checkBrokerAssign, setCheckBrokerAssign] = useState(true);
  const currentObjData = useState(location?.state?.currentReportObj);
  const [userDetails, setUserDetails] = useState({});
  const [check, setCheck] = useState(isCompliance === "0" ? false : true);
  const [checkCompleted, setCheckCompleted] = useState(true);
  const [checkInProgress, setCheckInProgress] = useState(true);
  const [checkOverdue, setCheckOverdue] = useState(true);
  const [checkYetToStart, setCheckYetToStart] = useState(true);
  // new designchanges 1-May-23
  const [isExpand, setIsExpand] = useState(false);
  const [localFilters, setLocalFilters] = useState({});
  const statusList = ["completed", "in-progress", "not-started"];
  const [selectedFilters, setSelectedFilters] = useState({
    dateRange: { start: "", end: "" },
    selectedProviderList: [],
    selectedOfficeList: [],
    selectedManagerCoachList: [],
    selectedBrokerageList: [],
    check: isCompliance === "0" ? false : true,
    selectedCourseList: [],
    selectedTeamMatesList: [],
    selectedStatus: ["completed", "in-progress", "not-started"],
    selectedRole: [
      "participant",
      // "reporting_manager",
      "program_manager",
      "all",
    ],
    selectedAssignment: [
      "self",
      "manager",
      "broker_admin",
      // , "api"
    ],
    selectedAgentStatus: [1],
    selectedCourseOrVideo: false,
    clickedApply: false,
  });

  const [userStatusFilter, setUserStatusFilter] = useState(1);
  const [pageNum, setPageNum] = useState(0);
  const [progressSort, setProgressSort] = useState("asc");
  const [searchInput, setSearchInput] = useState("");
  const [pageSize, setPageSize] = useState(50);

  const [showFilters, setShowFilters] = useState({
    reportingPeriod: true,
    provider: false,
    offices: true,
    reportingTo: false,
    learningContentType: isCompliance === "0" ? false : false,
    learningContent: true,
    agents: true,
    status: true,
    role: false,
    agentStatus: true,
    brokerage: false,
    roleFilter: {
      manager: true,
      guest: true,
      all: true,
      instructor: false,
      SystemUsageReports: false,
      rea: true,
    },
    assignmentFrom: false,
  });
  const [counterForOffice, setCounterForOffice] = useState(1);
  const [counterForMng, setCounterForMng] = useState(1);
  const [totalOffices, setTotalOffices] = useState([]);
  const [allFilterCount, setAllFilterCount] = useState(0);
  const [courseOrVideo, setCourseOrVideo] = useState();
  const [officeLabel, setOfficeLabel] = useState("");

  useEffect(() => {
    // setIsLoading(false)
    setOverAllLearningPoints([]);
    setOverAllOfficesData([]);
    setTotalOffices(0);
    setTotalManagers(0);
    setOverAllManagersData([]);
    setTotalRea([]);
    setRealEstateAgent([]);
    setProfileReports([]);
  }, [dispatch]);

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (
        !_.isEmpty(authBroker.payload?.user?.config) &&
        authBroker.payload?.user?.config.office_name
      ) {
        setOfficeLabel(authBroker.payload?.user?.config.office_name);
      } else {
        setOfficeLabel("Office Name");
      }
    }
  }, [authBroker]);

  useEffect(() => {
    if (!_.isEmpty(authIframeBroker)) {
      // alert(JSON.stringify(authIframeBroker.payload.user.config))
      if (
        !_.isEmpty(authIframeBroker.payload?.user?.config) &&
        authIframeBroker.payload?.user?.config.office_name
      ) {
        setOfficeLabel(authIframeBroker.payload?.user?.config.office_name);
      } else {
        setOfficeLabel("Office Name");
      }
    }
  }, [authIframeBroker]);

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (authBroker.status === "success") {
        if (authBroker.payload && authBroker.payload?.user) {
          if (authBroker.payload?.user?.is_corporate) {
            setShowFilters({
              reportingPeriod: true,
              provider: false,
              offices: true,
              reportingTo: false,
              learningContentType: isCompliance === "0" ? false : false,
              learningContent: true,
              agents: true,
              status: true,
              role: false,
              agentStatus: false,
              brokerages: true,
              roleFilter: {
                manager: true,
                guest: true,
                all: true,
                instructor: false,
                SystemUsageReports: false,
                rea: true,
              },
              assignmentFrom: false,
            });
            setIsExpand(true);
          }
        }
      }
    }
  }, [authBroker]);

  useEffect(() => {
    if (!_.isEmpty(authIframeBroker)) {
      if (authIframeBroker.payload && authIframeBroker.payload?.user) {
        if (authIframeBroker.payload?.user?.is_corporate) {
          setShowFilters({
            reportingPeriod: true,
            provider: false,
            offices: true,
            reportingTo: false,
            learningContentType: isCompliance === "0" ? false : false,
            learningContent: true,
            agents: true,
            status: true,
            role: false,
            agentStatus: false,
            brokerages: true,
            roleFilter: {
              manager: true,
              guest: true,
              all: true,
              instructor: false,
              SystemUsageReports: false,
              rea: true,
            },
            assignmentFrom: false,
          });
          setIsExpand(true);
        }
      }
    }
  }, [authIframeBroker]);

  useEffect(() => {
    if (filterId) {
      getSavedFiltersDataByIdFunc();
    }
    return () => {
      dispatch(getSavedFilterDataResponseClearById());
      console.log("filtersclear--", getSavedFiltersDataResponseById);
    };
  }, [filterId]);

  useEffect(() => {
    if (!_.isEmpty(getSavedFiltersDataResponseById)) {
      if (getSavedFiltersDataResponseById?.status === "success") {
        setSavedFiltersDataById(
          getSavedFiltersDataResponseById?.payload?.payload[0]
        );
      } else {
        setSavedFiltersDataById("");
      }
    }
  }, [getSavedFiltersDataResponseById]);

  useEffect(() => {
    if (savedFiltersDataById?.filter_content) {
      setIsLoading(true);

      const rea_ids = [];
      const manager_ids = [];
      const office_ids = [];
      const courseList = [];
      const providerList = [];

      let selectedFiltersById = savedFiltersDataById?.filter_content;

      selectedFiltersById.selectedOfficeList.forEach(function (obj) {
        office_ids.push(obj.office_id);
      });
      selectedFiltersById.selectedTeamMatesList.forEach(function (obj) {
        rea_ids.push(obj.user_id);
      });
      selectedFiltersById.selectedManagerCoachList.forEach(function (obj) {
        manager_ids.push(obj.id);
      });
      selectedFiltersById.selectedProviderList.forEach(function (obj) {
        providerList.push(obj.p_id);
      });
      selectedFiltersById.selectedCourseList.forEach(function (obj) {
        if (obj.source === "xsel") {
          courseList.push(obj.course_code);
        } else {
          courseList.push(obj.course_id);
        }
      });

      let userStatus = 1;
      if (_.isArray(selectedFiltersById?.selectedAgentStatus)) {
        if (
          selectedFiltersById?.selectedAgentStatus?.includes(3) ||
          (selectedFiltersById?.selectedAgentStatus?.includes(1) &&
            selectedFiltersById?.selectedAgentStatus?.includes(2))
        ) {
          userStatus = 3;
        } else if (selectedFiltersById?.selectedAgentStatus?.includes(1)) {
          userStatus = 1;
        } else if (selectedFiltersById?.selectedAgentStatus?.includes(2)) {
          userStatus = 2;
        }
      }

      dispatch(
        getProfileCompletionReport({
          module: "getCourseProgressReport",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            limit: counter,
            rea_ids: rea_ids,
            entity_id: courseList, //course_codes
            office_ids: selectedFilters.selectedOfficeList.map((o) =>
              _.toNumber(o.office_id)
            ),
            provider_ids: providerList,
            compliance: selectedFiltersById.check ? 1 : 0,
            manager_ids: manager_ids,
            date_range: selectedFiltersById.dateRange,
            status: selectedFiltersById.selectedStatus,
            role: selectedFiltersById.selectedRole,
            is_videos: selectedFiltersById.selectedCourseOrVideo,
            brokerage: selectedFilters.selectedBrokerageList,
            user_status: userStatus,
            assigner_role: selectedFiltersById.selectedAssignment,
          },
        })
      );

      dispatch(
        getCrsReportOffices({
          module: "getCourseReportOffices",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            office_ids: selectedFilters.selectedOfficeList.map((o) =>
              _.toNumber(o.office_id)
            ),
            rea_ids: rea_ids,
            limit: 1,
            entity_id: courseList,
            provider_ids: providerList,
            compliance: selectedFiltersById.check ? 1 : 0,
            manager_ids: manager_ids,
            date_range: selectedFiltersById.dateRange,
            status: selectedFiltersById.selectedStatus,
            role: selectedFiltersById.selectedRole,
            is_videos: selectedFiltersById.selectedCourseOrVideo,
            brokerage: selectedFilters.selectedBrokerageList,
            user_status: userStatus,
            assigner_role: selectedFiltersById.selectedAssignment,
          },
        })
      );

      dispatch(
        getCrsReportManagers({
          module: "getCourseReportManagers",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            limit: 1,
            office_ids: selectedFilters.selectedOfficeList.map((o) =>
              _.toNumber(o.office_id)
            ),
            rea_ids: rea_ids,
            entity_id: courseList,
            provider_ids: providerList,
            compliance: selectedFiltersById.check ? 1 : 0,
            manager_ids: manager_ids,
            date_range: selectedFiltersById.dateRange,
            status: selectedFiltersById.selectedStatus,
            role: selectedFiltersById.selectedRole,
            is_videos: selectedFiltersById.selectedCourseOrVideo,
            brokerage: selectedFilters.selectedBrokerageList,
            user_status: userStatus,
            assigner_role: selectedFiltersById.selectedAssignment,
          },
        })
      );

      dispatch(
        getCrsReportRea({
          module: "getCourseReportRea",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            rea_ids: rea_ids,
            limit: 1,
            office_ids: selectedFilters.selectedOfficeList.map((o) =>
              _.toNumber(o.office_id)
            ),
            entity_id: courseList,
            compliance: selectedFiltersById.check ? 1 : 0,
            provider_ids: providerList,
            manager_ids: manager_ids,
            date_range: selectedFiltersById.dateRange,
            status: selectedFiltersById.selectedStatus,
            role: selectedFiltersById.selectedRole,
            is_videos: selectedFiltersById.selectedCourseOrVideo,
            brokerage: selectedFilters.selectedBrokerageList,
            user_status: userStatus,
            assigner_role: selectedFiltersById.selectedAssignment,
          },
        })
      );

      setTrendLoaderChart(true);
      // dispatch(
      //   getCrsReportTrend({
      //     module: "getCourseReportTrend",
      //     postData: {
      //       token: isMobile
      //         ? localStorage.getItem(SessionKeys.API_TOKEN)
      //         : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      //       office_ids: office_ids,
      //       rea_ids: rea_ids,
      //       entity_id: courseList,
      //       compliance: selectedFiltersById.check ? 1 : 0,
      //       year: _.toNumber(trendYear),
      //       provider_ids: providerList,
      //       manager_ids: manager_ids,
      //       date_range: selectedFiltersById.dateRange,
      //       status: selectedFiltersById.selectedStatus,
      //       role: selectedFiltersById.selectedRole,
      //       is_videos: selectedFiltersById.selectedCourseOrVideo,
      //     },
      //   })
      // );

      getSingleCompletionTrend(courseList);

      dispatch(
        getCrsReportStats({
          module: "getCourseReportStats",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            office_ids: selectedFilters.selectedOfficeList.map((o) =>
              _.toNumber(o.office_id)
            ),
            rea_ids: rea_ids,
            entity_id: courseList,
            compliance: selectedFiltersById.check ? 1 : 0,
            manager_ids: manager_ids,
            provider_ids: providerList,
            date_range: selectedFiltersById.dateRange,
            status: selectedFiltersById.selectedStatus,
            role: selectedFiltersById.selectedRole,
            is_videos: selectedFiltersById.selectedCourseOrVideo,
            brokerage: selectedFilters.selectedBrokerageList,
            user_status: userStatus,
            assigner_role: selectedFiltersById.selectedAssignment,
          },
        })
      );
    }
  }, [savedFiltersDataById]);

  useEffect(() => {
    console.log("isCompliance: ", isCompliance);
    if (isCompliance === "0") {
      setCheck(false);
    }
  }, [isCompliance]);

  useEffect(() => {
    if (pageNum && !isLoading) {
      setIsLoading(true);
      setIsLoading(true);
      fetchCrsTableReport();
    }
  }, [pageNum, pageSize, progressSort, searchInput]);

  useEffect(() => {
    if (!_.isEmpty(localFilters) && localStorage.getItem("SELECTED_FILTER")) {
      localStorage.removeItem("SELECTED_FILTER");
    }
  }, [localFilters]);

  useEffect(() => {
    console.log(
      "selectedFilters: ",
      selectedFilters,
      !filterId,
      !localStorage.getItem("SELECTED_FILTER")
    );

    if (authBroker?.payload?.user || authIframeBroker?.payload?.user) {
      if (
        (authBroker.payload?.user?.is_corporate ||
          authIframeBroker.payload?.user?.is_corporate) &&
        _.isEmpty(localStorage.getItem("SELECTED_FILTER"))
      ) {
        if (selectedFilters.clickedApply) {
          if (selectedFilters.selectedBrokerageList.length == 0) {
            // alert('office requried');
            setIsLoading(false);
            setConfirmModal(true);
          } else {
            setSearchInput("");
            setTimeout(() => {
              setUserStatusFilter(1);
              setPageNum(0);
              setProgressSort("asc");
              setCounter(1);
              setCounterForMng(1);
              setCounterForOffice(1);
              setSelectedValue();
              hitAllFilterApi(1, "", "asc");
            }, 1000);
            localStorage.removeItem("SELECTED_FILTER");
          }
        } else {
          setIsLoading(false);
          setOverAllLearningPoints([]);
          setOverAllOfficesData([]);
          setTotalOffices(0);
          setTotalManagers(0);
          setOverAllManagersData([]);
          setTotalRea({
            total_rea: 0,
          });
          setRealEstateAgent([]);
          setProfileReports([]);
        }
      } else if (
        (!_.isEmpty(selectedFilters) &&
          !filterId &&
          !localStorage.getItem("SELECTED_FILTER")) ||
        selectedFilters?.clickedApply
      ) {
        setSearchInput("");
        setTimeout(() => {
          setUserStatusFilter(1);
          setPageNum(0);
          setProgressSort("asc");
          setCounter(1);
          setCounterForMng(1);
          setCounterForOffice(1);
          setSelectedValue();
          hitAllFilterApi(1, "", "asc");
        }, 1000);
        localStorage.removeItem("SELECTED_FILTER");
      } else if (localStorage.getItem("SELECTED_FILTER")) {
        console.log(
          "selected filters----",
          JSON.parse(localStorage.getItem("SELECTED_FILTER"))
        );
        const filterData = JSON.parse(localStorage.getItem("SELECTED_FILTER"));
        if (!filterData.isLP) {
          setSelectedFilters(filterData.selectedFilters);
          setLocalFilters(filterData.selectedFilters);
          setIsExpand(true);
        } else {
          setCounter(1);
          setCounterForMng(1);
          setCounterForOffice(1);
          setSelectedValue();
          hitAllFilterApi();
          localStorage.removeItem("SELECTED_FILTER");
        }
        // setTimeout(() => {
        //   localStorage.removeItem('SELECTED_FILTER')
        // }, 1000)
      }
    }
  }, [selectedFilters, authBroker, authIframeBroker]);

  useEffect(() => {
    // console.log('userDetailRes: ', userDetailRes)
    if (isMobile) {
      if (!_.isEmpty(userDetailIframe?.payload?.payload)) {
        setUserDetails(userDetailIframe?.payload?.payload);
      }
    } else {
      if (!_.isEmpty(userDetailRes?.payload?.payload)) {
        setUserDetails(userDetailRes?.payload?.payload);
      }
    }
  }, [userDetailRes, userDetailIframe, isMobile]);

  useEffect(() => {
    setSelectedValue();
    if (
      ((!filterId || selectedFilters?.clickedApply) &&
        !localStorage.getItem("SELECTED_FILTER") &&
        (authBroker.payload?.user || authIframeBroker.payload?.user) &&
        !(
          authBroker.payload?.user?.is_corporate ||
          authIframeBroker.payload?.user?.is_corporate
        )) ||
      counter > 1
    ) {
      hitReaListApi(counter);
    }
  }, [counter]);

  useEffect(() => {
    setSelectedValue();
    if (
      (!filterId || selectedFilters?.clickedApply) &&
      !localStorage.getItem("SELECTED_FILTER") &&
      (authBroker.payload?.user || authIframeBroker.payload?.user) &&
      !(
        authBroker.payload?.user?.is_corporate ||
        authIframeBroker.payload?.user?.is_corporate
      )
    ) {
      hitManagerListApi(counterForMng);
    }
  }, [counterForMng]);

  useEffect(() => {
    setSelectedValue();
    if (
      ((!filterId || selectedFilters?.clickedApply) &&
        !localStorage.getItem("SELECTED_FILTER") &&
        (authBroker.payload?.user || authIframeBroker.payload?.user) &&
        !(
          authBroker.payload?.user?.is_corporate ||
          authIframeBroker.payload?.user?.is_corporate
        )) ||
      counterForOffice > 1
    ) {
      hitOfficeListApi(counterForOffice);
    }
  }, [counterForOffice]);

  // useEffect(() => {
  //   if (!filterId || selectedFilters?.clickedApply) {
  //     hitTrendingApi();
  //   }
  //   // setFilterBy(FILTER_BY[0].value);
  // }, [trendYear]);

  useEffect(() => {
    if (!_.isEmpty(profileReportRes)) {
      let legends = [];
      let series = [];
      if (profileReportRes?.status === "success") {
        // setIsLoading(false);
        const reportData = profileReportRes?.payload?.payload?.user_data;
        setProfileReports(profileReportRes?.payload?.payload);
        setProfileReportsFilter(reportData);
        setIsLoading(false);
        if (statusFilterData.includes("Completed")) {
          let completedCount = reportData?.filter(
            (data) => data.profile_status === "Completed"
          ).length;
          series.push(
            reportData?.filter((data) => data.profile_status === "Completed")
              .length
          );
          legends.push(`Completed (${completedCount})`);
        }
        if (statusFilterData.includes("Inprogress")) {
          let inprogressCount = reportData?.filter(
            (data) => data.profile_status === "Inprogress"
          ).length;
          series.push(
            reportData?.filter((data) => data.profile_status === "Inprogress")
              .length
          );
          legends.push(`In Progress(${inprogressCount})`);
        }
        if (statusFilterData.includes("OverDue")) {
          let overdueCount = reportData?.filter(
            (data) => data.profile_status === "OverDue"
          ).length;
          series.push(
            reportData?.filter((data) => data.profile_status === "OverDue")
              .length
          );
          legends.push(`Overdue(${overdueCount})`);
        }
        if (statusFilterData.includes("Yet to start")) {
          let notStartedCount = reportData?.filter(
            (data) => data.profile_status === "Yet to start"
          ).length;
          series.push(
            reportData?.filter((data) => data.profile_status === "Yet to start")
              .length
          );
          // legends.push(`Yet to start (${notStartedCount})`);
          legends.push(`Yet to start (${notStartedCount})`);
        }
        setLegends(legends);
        setSeries(series);
        setCurrentPage(1);
      } else {
        setProfileReports([]);
        setCanShow(false);
        // setIsLoading(false);
      }
      dispatch(getProfileCompletionReportClear());
    }
  }, [profileReportRes]);

  useEffect(() => {
    if (!_.isEmpty(anyTotalReportRes)) {
      if (anyTotalReportRes.status === "success") {
        setTotalRecord(anyTotalReportRes.payload.payload.length);
      }
      return () => {
        dispatch(getAnyTotalReportClear());
      };
    }
  }, [anyTotalReportRes]);

  useEffect(() => {
    dispatch(getCrsReportStatsClear());
  }, [dispatch]);

  useEffect(() => {
    setCounter(1);
    setRealEstateAgent([]);
    return () => {
      dispatch(getCrsReportReaClear());
    };
  }, []);

  //LP Rea
  useEffect(() => {
    if (!_.isEmpty(crsReaRes)) {
      setLoadSpin(false);
      if (crsReaRes?.status === "success") {
        let allData = [];
        allData = sortByAlphabetical(
          crsReaRes?.payload?.payload?.real_estate_agents
        );
        let realEstateAgents = crsReaRes?.payload?.payload?.real_estate_agents;
        setTotalRea(crsReaRes?.payload?.payload);
        let temparr = _.cloneDeep(realEstateAgent);
        if (counter === 1) {
          temparr = [];
        }
        setReaList([...temparr, ...allData]);
        setLimitStatus(crsReaRes?.payload?.payload?.real_estate_agents);
        let reaData = [...temparr, ...allData];
        let reportType = selectedFilters.check
          ? "compliance"
          : "learningprogress";
        reaData = formatREACardData(reaData, reportType, isMobile);
        setRealEstateAgent(reaData);
        setActualCoursesList(reaData);
        dispatch(getCrsReportReaClear());
      } else {
        setRealEstateAgent([]);
        setActualCoursesList([]);
      }
    }
  }, [crsReaRes]);

  useEffect(() => {
    return () => {
      dispatch(getCrsReportTrendClear());
    };
  }, []);

  useEffect(() => {
    getAssignmentFromArray();
  }, [checkSelfAssign, checkManagerAssign, checkApiAssign, checkBrokerAssign]);

  useEffect(() => {
    getStatusArr();
  }, [checkCompleted, checkInProgress, checkOverdue, checkYetToStart]);

  //Compliance Completion trend
  useEffect(() => {
    if (!_.isEmpty(crsTrendRes)) {
      setImgLoader(false);
      setLoaderChart(false);
      setTrendLoaderChart(false);
      if (crsTrendRes?.status === "success") {
        let allData = [];
        allData = crsTrendRes?.payload?.payload?.completion_trend;
        let trendData = Object.entries(allData); //Object.values(allData)
        let tempArrTrend = [["", "Percentage"]];

        for (const [key, value] of trendData) {
          tempArrTrend.push([key, value]);
        }
        setCrsCompltTrendValues(tempArrTrend);

        // setCrsCompltTrendValues(Object.values(allData));
        setFilterYearData(crsTrendRes?.payload?.payload?.year);
        setTrendFilterCourses(crsTrendRes?.payload?.payload?.courses);

        let tempArr = [];
        let tempArrSeries = [];
        let legend = crsTrendRes?.payload?.payload?.legends_data;
        tempArr.push(`Completed (${legend?.completed})`);
        tempArrSeries.push(legend?.completed);
        tempArr.push(`In Progress(${legend?.inprogress})`);
        tempArrSeries.push(legend?.inprogress);
        tempArr.push(`Overdue(${legend?.overdue})`);
        tempArrSeries.push(legend?.overdue);
        tempArr.push(`Yet to start (${legend?.notstarted})`);
        tempArrSeries.push(legend?.notstarted);
        setLegendOfAll(tempArr);
        console.log("tempArrSeries", tempArrSeries);
        setSeriesOfAll(tempArrSeries);

        dispatch(getCrsReportTrendClear());
      }
    }
  }, [crsTrendRes]);

  useEffect(() => {
    if (!_.isEmpty(crsReportTrendOfSingleRes)) {
      setImgLoader(false);
      // setIsLoading(false);
      setLoaderChart(false);
      if (crsReportTrendOfSingleRes?.status === "success") {
        let allData = [];
        allData = crsReportTrendOfSingleRes?.payload?.payload?.completion_trend;
        let trendData = Object.entries(allData); //Object.values(allData)
        let tempArrTrend = [["", "Percentage"]];

        for (const [key, value] of trendData) {
          tempArrTrend.push([key, value]);
        }
        let seriesSingle = Object.values(allData);
        // if (Number(selectedYear) === (new Date().getFullYear())) {
        let tempSeries = [];
        for (let i = 0; i < seriesSingle.length; i++) {
          const element = seriesSingle[i];
          if (i <= new Date().getMonth()) {
            tempSeries.push(element);
          } else {
            tempSeries.push(null);
          }
        }
        // }
        setCrsCompltTrendValuesOfSingle(tempSeries);
        // setFilterYearDataOfSingle(crsReportTrendOfSingleRes?.payload?.payload?.year)

        let tempArr = [];
        let tempArrSeries = [];
        let legend = crsReportTrendOfSingleRes?.payload?.payload?.legends_data;
        tempArr.push(`Completed (${legend?.completed})`);
        tempArrSeries.push(legend?.completed);
        tempArr.push(`In Progress(${legend?.inprogress})`);
        tempArrSeries.push(legend?.inprogress);
        tempArr.push(`Overdue(${legend?.overdue})`);
        tempArrSeries.push(legend?.overdue);
        tempArr.push(`Yet to start (${legend?.notstarted})`);
        tempArrSeries.push(legend?.notstarted);

        setLegendOfSingle(tempArr);
        setSeriesOfSingle(tempArrSeries);
        dispatch(getCrsReportTrendOfSingleClear());
      }
    }
  }, [crsReportTrendOfSingleRes]);

  //Compliance Stats
  useEffect(() => {
    if (!_.isEmpty(crsStatsRes)) {
      if (crsStatsRes?.status === "success") {
        setIsLoaded(false);
        let allData = crsStatsRes?.payload?.payload?.stats;
        setOverAllLearningPoints(allData);
      } else {
        setOverAllLearningPoints([]);
      }
      dispatch(getCrsReportStatsClear());
    }
  }, [crsStatsRes]);

  const getSavedFiltersDataByIdFunc = () => {
    setIsLoading(true);
    dispatch(
      getSavedFilterDataById({
        module: "getSavedFiltersDataById",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          id: filterId,
        },
      })
    );
  };

  // useEffect(() => {
  //   console.log("selected filters----test", selectedFilters);
  //   if (_.isEqual(selectedFilters, initSelectedFilters)) {
  //   } else {
  //     // localStorage.setItem("SELECTED_FILTER", JSON.stringify(selectedFilters));
  //   }
  // }, [selectedFilters]);

  // useEffect(() => {
  //   if (localStorage.getItem("SELECTED_FILTER")) {
  //     console.log(
  //       "selected filters----",
  //       JSON.parse(localStorage.getItem("SELECTED_FILTER"))
  //     );
  //     setSelectedFilters(JSON.parse(localStorage.getItem("SELECTED_FILTER")));
  //     localStorage.removeItem('SELECTED_FILTER')
  //   }
  // }, [dispatch]);

  const setSelectedValue = () => {
    selectedFilters.selectedOfficeList.forEach(function (obj) {
      office_ids.push(obj.office_id);
    });
    selectedFilters.selectedTeamMatesList.forEach(function (obj) {
      rea_ids.push(obj.user_id);
    });
    selectedFilters.selectedManagerCoachList.forEach(function (obj) {
      manager_ids.push(obj.id);
    });
    selectedFilters.selectedProviderList.forEach(function (obj) {
      providerList.push(obj.p_id);
    });
    selectedFilters.selectedCourseList.forEach(function (obj) {
      if (obj.source === "xsel") {
        courseList.push(obj.course_code);
      } else {
        courseList.push(obj.course_id);
      }
    });
  };

  // COUNT INCREAMENT
  function setCount(counter, setCounter) {
    return setCounter(counter + 1);
  }

  function setCountForOffice(counter, setCounterForOffice) {
    return setCounterForOffice(counter + 1);
  }

  function setCountForManager(counter, setCounterForMng) {
    return setCounterForMng(counter + 1);
  }

  const getAssignmentFromArray = () => {
    let assignArray = [];
    if (checkApiAssign) {
      assignArray.push("api");
    }
    if (checkManagerAssign) {
      assignArray.push("manager");
    }
    if (checkSelfAssign) {
      assignArray.push("self");
    }
    if (checkBrokerAssign) {
      assignArray.push("broker_admin");
    }
    setSelectedAssignment(assignArray);
    return selectedAssignment;
  };

  const getStatusArr = () => {
    let statusArr = [];
    if (checkCompleted) {
      statusArr.push("completed");
    }
    if (checkInProgress) {
      statusArr.push("in-progress");
    }
    if (checkOverdue) {
      statusArr.push("overdue");
    }
    if (checkYetToStart) {
      statusArr.push("not-started");
    }
    setSelectedStatus(statusArr);
    return statusArr;
  };

  const hitReaListApi = (counter, userStatus = 3) => {
    console.log("current filters selectedFilters REA", selectedFilters);
    if (_.isArray(selectedFilters.selectedAgentStatus)) {
      if (
        selectedFilters.selectedAgentStatus.includes(3) ||
        (selectedFilters.selectedAgentStatus.includes(1) &&
          selectedFilters.selectedAgentStatus.includes(2))
      ) {
        userStatus = 3;
      } else if (selectedFilters.selectedAgentStatus.includes(1)) {
        userStatus = 1;
      } else if (selectedFilters.selectedAgentStatus.includes(2)) {
        userStatus = 2;
      }
    }
    let statusArr = getStatusArr();
    dispatch(
      getCrsReportRea({
        module: "getCourseReportRea",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          rea_ids: rea_ids,
          limit: counter,
          office_ids: selectedFilters.selectedOfficeList.map((o) =>
            _.toNumber(o.office_id)
          ),
          entity_id: courseList,
          compliance: selectedFilters.check ? 1 : 0,
          provider_ids: providerList,
          manager_ids: manager_ids,
          date_range: selectedFilters.dateRange,
          status:
            selectedFilters?.selectedStatus.length === 3
              ? [...selectedFilters?.selectedStatus, "overdue"]
              : selectedFilters?.selectedStatus,
          role: selectedFilters.selectedRole,
          is_videos: selectedFilters.selectedCourseOrVideo,
          brokerage: selectedFilters.selectedBrokerageList,
          user_status: userStatus,
          assigner_role: selectedFilters.selectedAssignment,
        },
      })
    );
  };

  const hitOfficeListApi = (counterForOffice, userStatus = 3) => {
    if (_.isArray(selectedFilters.selectedAgentStatus)) {
      if (
        selectedFilters.selectedAgentStatus.includes(3) ||
        (selectedFilters.selectedAgentStatus.includes(1) &&
          selectedFilters.selectedAgentStatus.includes(2))
      ) {
        userStatus = 3;
      } else if (selectedFilters.selectedAgentStatus.includes(1)) {
        userStatus = 1;
      } else if (selectedFilters.selectedAgentStatus.includes(2)) {
        userStatus = 2;
      }
    }
    // Office list api
    dispatch(
      getCrsReportOffices({
        module: "getCourseReportOffices",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          office_ids: selectedFilters.selectedOfficeList.map((o) =>
            _.toNumber(o.office_id)
          ),
          rea_ids: rea_ids,
          limit: counterForOffice,
          entity_id: courseList,
          provider_ids: providerList,
          compliance: selectedFilters.check ? 1 : 0,
          manager_ids: manager_ids,
          date_range: selectedFilters.dateRange,
          status:
            selectedFilters?.selectedStatus.length === 3
              ? [...selectedFilters?.selectedStatus, "overdue"]
              : selectedFilters?.selectedStatus,
          role: selectedFilters.selectedRole,
          is_videos: selectedFilters.selectedCourseOrVideo,
          brokerage: selectedFilters.selectedBrokerageList,
          user_status: userStatus,
          assigner_role: selectedFilters.selectedAssignment,
        },
      })
    );
  };

  const hitManagerListApi = (counterForMng, userStatus = 3) => {
    if (_.isArray(selectedFilters.selectedAgentStatus)) {
      if (
        selectedFilters.selectedAgentStatus.includes(3) ||
        (selectedFilters.selectedAgentStatus.includes(1) &&
          selectedFilters.selectedAgentStatus.includes(2))
      ) {
        userStatus = 3;
      } else if (selectedFilters.selectedAgentStatus.includes(1)) {
        userStatus = 1;
      } else if (selectedFilters.selectedAgentStatus.includes(2)) {
        userStatus = 2;
      }
    }
    dispatch(
      getCrsReportManagers({
        module: "getCourseReportManagers",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          limit: counterForMng,
          office_ids: selectedFilters.selectedOfficeList.map((o) =>
            _.toNumber(o.office_id)
          ),
          rea_ids: rea_ids,
          entity_id: courseList,
          provider_ids: providerList,
          compliance: selectedFilters.check ? 1 : 0,
          manager_ids: manager_ids,
          date_range: selectedFilters.dateRange,
          status:
            selectedFilters?.selectedStatus.length === 3
              ? [...selectedFilters?.selectedStatus, "overdue"]
              : selectedFilters?.selectedStatus,
          role: selectedFilters.selectedRole,
          is_videos: selectedFilters.selectedCourseOrVideo,
          brokerage: selectedFilters.selectedBrokerageList,
          user_status: userStatus,
          assigner_role: selectedFilters.selectedAssignment,
        },
      })
    );
  };

  const hitTrendingApi = () => {
    setTrendLoaderChart(true);
    let statusArr = getStatusArr();
    dispatch(
      getCrsReportTrend({
        module: "getCourseReportTrend",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          office_ids: selectedFilters.selectedOfficeList.map((o) =>
            _.toNumber(o.office_id)
          ),
          rea_ids: rea_ids,
          entity_id: courseList,
          compliance: selectedFilters.check ? 1 : 0,
          year: _.toNumber(trendYear),
          provider_ids: providerList,
          manager_ids: manager_ids,
          date_range: selectedFilters.dateRange,
          status:
            selectedFilters?.selectedStatus.length === 3
              ? [...selectedFilters?.selectedStatus, "overdue"]
              : selectedFilters?.selectedStatus,
          role: selectedFilters.selectedRole,
          is_videos: selectedFilters.selectedCourseOrVideo,
          brokerage: selectedFilters.selectedBrokerageList,
          assigner_role: selectedFilters.selectedAssignment,
        },
      })
    );
  };
  const hitAllFilterApi = (page = 0, searchTerm = "", progressSort = "asc") => {
    // ["","in-progress","not-started"],
    console.log("current filters selectedFilters", selectedFilters);
    setCrsCompltTrendValuesOfSingle([]);
    let statusArr = getStatusArr();

    let userStatus = 4;
    if (_.isArray(selectedFilters.selectedAgentStatus)) {
      if (
        selectedFilters.selectedAgentStatus.includes(3) ||
        (selectedFilters.selectedAgentStatus.includes(1) &&
          selectedFilters.selectedAgentStatus.includes(2))
      ) {
        userStatus = 3;
      } else if (selectedFilters.selectedAgentStatus.includes(1)) {
        userStatus = 1;
      } else if (selectedFilters.selectedAgentStatus.includes(2)) {
        userStatus = 2;
      }
    }
    setUserStatusFilter(userStatus);

    fetchCrsTableReport(userStatus, page, searchTerm, progressSort);

    setIsLoading(true);
    hitOfficeListApi(1, userStatus);
    hitManagerListApi(1, userStatus);
    hitReaListApi(1, userStatus);

    setLoaderChart(true);
    // hitTrendingApi();

    // getSingleCompletionTrend(courseList);

    dispatch(
      getCrsReportStats({
        module: "getCourseReportStats",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          office_ids: selectedFilters.selectedOfficeList.map((o) =>
            _.toNumber(o.office_id)
          ),
          rea_ids: rea_ids,
          entity_id: courseList,
          compliance: selectedFilters.check ? 1 : 0,
          manager_ids: manager_ids,
          provider_ids: providerList,
          date_range: selectedFilters.dateRange,
          status:
            selectedFilters?.selectedStatus.length === 3
              ? [...selectedFilters?.selectedStatus, "overdue"]
              : selectedFilters?.selectedStatus,
          role: selectedFilters.selectedRole,
          is_videos: selectedFilters.selectedCourseOrVideo,
          brokerage: selectedFilters.selectedBrokerageList,
          user_status: userStatus,
          assigner_role: selectedFilters.selectedAssignment,
        },
      })
    );
  };

  const fetchCrsTableReport = (
    userStatus,
    page = 0,
    searchTerm = "",
    sort = ""
  ) => {
    // selectedFilters.selectedOfficeList.forEach(function (obj) {
    //   office_ids.push(obj.office_id);
    // });
    // selectedFilters.selectedTeamMatesList.forEach(function (obj) {
    //   rea_ids.push(obj.user_id);
    // });
    // selectedFilters.selectedManagerCoachList.forEach(function (obj) {
    //   manager_ids.push(obj.id);
    // });
    // selectedFilters.selectedProviderList.forEach(function (obj) {
    //   providerList.push(obj.p_id);
    // });
    // selectedFilters.selectedCourseList.forEach(function (obj) {
    //   if (obj.source === "xsel") {
    //     courseList.push(obj.course_code);
    //   } else {
    //     courseList.push(obj.course_id);
    //   }
    // });

    dispatch(
      getProfileCompletionReport({
        module: "getCourseProgressReport",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          limit: counter,
          rea_ids: selectedFilters.selectedTeamMatesList.map((r) =>
            _.toNumber(r.user_id)
          ),
          entity_id: selectedFilters.selectedCourseList.map((c) => {
            if (c.source === "xsel") return c.course_code;
            else return _.toNumber(c.course_id);
          }), //course_codes
          office_ids: selectedFilters.selectedOfficeList.map((o) =>
            _.toNumber(o.office_id)
          ),
          provider_ids: selectedFilters.selectedProviderList.map((p) => p.p_id),
          compliance: selectedFilters.check ? 1 : 0,
          manager_ids: selectedFilters.selectedManagerCoachList.map((m) =>
            _.toNumber(m.id)
          ),
          date_range: selectedFilters.dateRange,
          status:
            selectedFilters?.selectedStatus.length === 3
              ? [...selectedFilters?.selectedStatus, "overdue"]
              : selectedFilters?.selectedStatus,
          role: selectedFilters.selectedRole,
          is_videos: selectedFilters.selectedCourseOrVideo,
          brokerage: selectedFilters.selectedBrokerageList,
          user_status: userStatus ? userStatus : userStatusFilter,
          page: page ? page : pageNum ? pageNum : 1,
          page_size: pageSize,
          sortBy: sort ? sort : progressSort ? progressSort : "asc",
          search: searchTerm ? searchTerm : searchInput ? searchInput : "",
          assigner_role: selectedFilters.selectedAssignment,
        },
      })
    );
  };

  const getSingleCompletionTrend = (courseList) => {
    // setIsLoading(true)
    setLoaderChart(true);
    let statusArr = getStatusArr();
    dispatch(
      getCrsReportTrendOfSingle({
        module: "getCourseReportTrend",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          office_ids: selectedFilters.selectedOfficeList.map((o) =>
            _.toNumber(o.office_id)
          ),
          entity_id: courseList,
          rea_ids: rea_ids,
          compliance: selectedFilters.check ? 1 : 0,
          provider_ids: providerList,
          manager_ids: manager_ids,
          date_range: selectedFilters.dateRange,
          status:
            selectedFilters?.selectedStatus.length === 3
              ? [...selectedFilters?.selectedStatus, "overdue"]
              : selectedFilters?.selectedStatus,
          role: selectedFilters.selectedRole,
          is_videos: selectedFilters.selectedCourseOrVideo,
          brokerage: selectedFilters.selectedBrokerageList,
          assigner_role: selectedFilters.selectedAssignment,
        },
      })
    );
  };

  const searchTable = (searchVal) => {
    let list = _.cloneDeep(profileReportsFilter);
    if (searchVal === "") {
      setProfileReports(list);
      return;
    }

    let filterBySearch = [];

    for (const item of list) {
      let user_status = "";
      if (item?.user_status) {
        user_status = "active";
      } else {
        user_status = "in active";
      }
      if (
        item?.first_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.last_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.full_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.course_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.user_manager_name
          ?.toLowerCase()
          .includes(searchVal.toLowerCase()) ||
        user_status?.toLowerCase().includes(searchVal.toLowerCase())
      ) {
        filterBySearch.push(item);
      }
    }
    console.log("filterBySearch: ", filterBySearch);
    setProfileReports(filterBySearch);
  };

  const currentTableData = useMemo(() => {
    if (!_.isEmpty(profileReports)) {
      // if (profileReports !== null) {
      // const firstPageIndex = (currentPage - 1) * PageSize;
      // const lastPageIndex = firstPageIndex + PageSize;
      // setCanShow(true);
      // return profileReports?.slice(firstPageIndex, lastPageIndex);
      return profileReports.user_data;
    }
  }, [currentPage, profileReports]);

  const sortByAlphabetical = (list) => {
    return list?.sort((a, b) => b.learning_points - a.learning_points);
  };

  const sortByProgress = (list) => {
    return list?.sort(
      (a, b) =>
        _.toNumber(b.learning_percentage) - _.toNumber(a.learning_percentage)
    );
  };

  const sortByLearningHrs = (list) => {
    return list?.sort(
      (a, b) => _.toNumber(b.learning_hrs) - _.toNumber(a.learning_hrs)
    );
  };

  // useEffect(() => {
  //   if (counter > 1)
  //     sortAfterLoadMore();
  // }, [actualCoursesList])

  const sortAfterLoadMore = () => {
    if (filterBy === "Learning Points") {
      const sortedList = sortByAlphabetical(actualCoursesList);
      let reaData = sortedList;
      let reportType = selectedFilters.check
        ? "compliance"
        : "learningprogress";
      reaData = formatREACardData(reaData, reportType, isMobile);
      setRealEstateAgent(reaData);
    } else if (filterBy === "Progress") {
      const sortedList = sortByProgress(actualCoursesList);
      let reaData = sortedList;
      let reportType = selectedFilters.check
        ? "compliance"
        : "learningprogress";
      reaData = formatREACardData(reaData, reportType, isMobile);
      setRealEstateAgent(reaData);
    } else if (filterBy === "Learning Hours") {
      const sortedList = sortByLearningHrs(actualCoursesList);
      let reaData = sortedList;
      let reportType = selectedFilters.check
        ? "compliance"
        : "learningprogress";
      reaData = formatREACardData(reaData, reportType, isMobile);
      setRealEstateAgent(reaData);
    } else {
      let reaData = reaList;
      let reportType = selectedFilters.check
        ? "compliance"
        : "learningprogress";
      reaData = formatREACardData(reaData, reportType, isMobile);
      setRealEstateAgent(reaData);
      // setRealEstateAgent(reaList)
    }
  };

  const ExportToExcel = async () => {
    setIsLoading(true);
    selectedFilters.selectedOfficeList.forEach(function (obj) {
      office_ids.push(obj.office_id);
    });
    selectedFilters.selectedTeamMatesList.forEach(function (obj) {
      rea_ids.push(obj.user_id);
    });
    selectedFilters.selectedManagerCoachList.forEach(function (obj) {
      manager_ids.push(obj.id);
    });
    selectedFilters.selectedProviderList.forEach(function (obj) {
      providerList.push(obj.p_id);
    });
    selectedFilters.selectedCourseList.forEach(function (obj) {
      if (obj.source === "xsel") {
        courseList.push(obj.course_code);
      } else {
        courseList.push(obj.course_id);
      }
    });
    await axios
      .post(
        `${CONFIG.API_URL_BROKER_ADMIN}${API_LIST.BROKER_API.COURSE_REPORT}`,
        {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          limit: counter,
          rea_ids: selectedFilters.selectedTeamMatesList.map((r) =>
            _.toNumber(r.user_id)
          ),
          entity_id: selectedFilters.selectedCourseList.map((c) => {
            if (c.source === "xsel") return c.course_code;
            else return _.toNumber(c.course_id);
          }), //course_codes
          office_ids: selectedFilters.selectedOfficeList.map((o) =>
            _.toNumber(o.office_id)
          ),
          provider_ids: selectedFilters.selectedProviderList.map((p) => p.p_id),
          compliance: selectedFilters.check ? 1 : 0,
          manager_ids: selectedFilters.selectedManagerCoachList.map((m) =>
            _.toNumber(m.id)
          ),
          date_range: selectedFilters.dateRange,
          status:
            selectedFilters?.selectedStatus.length === 3
              ? [...selectedFilters?.selectedStatus, "overdue"]
              : selectedFilters?.selectedStatus,
          role: selectedFilters.selectedRole,
          is_videos: selectedFilters.selectedCourseOrVideo,
          brokerage: selectedFilters.selectedBrokerageList,
          user_status: userStatusFilter,
          page: pageNum ? pageNum : 1,
          page_size: pageSize,
          sortBy: progressSort ? progressSort : "asc",
          search: searchInput ? searchInput : "",
          isDownload: true,
          assigner_role: selectedFilters.selectedAssignment,
        },
        { header: { "Content-Type": "application/json" } }
      )
      .then((response) => {
        if (response.data.status) {
          const userRecords = response.data?.data?.user_data;
          if (!_.isEmpty(userRecords)) {
            const data = _.cloneDeep(userRecords);
            console.log(data);
            for (let item of data) {
              item.profile_status =
                item?.profile_status === "Inprogress" ||
                item?.profile_status === "in-progress" ||
                item?.profile_status === "inprogress"
                  ? "In Progress"
                  : item?.profile_status === "Yet to start" ||
                    item?.profile_status === "not-started"
                  ? "Yet to start"
                  : item?.profile_status === "OverDue" ||
                    item?.profile_status === "overdue" ||
                    item?.profile_status === "over-due"
                  ? "Overdue"
                  : "Completed";
              item.profile_progress =
                item?.profile_progress !== undefined &&
                item?.profile_progress !== ""
                  ? item?.profile_progress + "%"
                  : "-";
              item.complete_date =
                item?.complete_date !== undefined &&
                item?.complete_date !== "" &&
                item?.complete_date !== null
                  ? moment.unix(item.complete_date).utc().format("DD/MM/YYYY hh:mm A")
                  : "-";
                  item.asset_type = item?.asset_type ? item?.asset_type : "-";
                  item.duration = item?.duration ? formatMinutes(item?.duration) : "-";
                  item.course_id = item?.course_id ? item?.course_id : "-";
            }

            const parser = new DOMParser();

            //for sequencing
            let tempArr = [];
            for (const item of data) {
              const doc = parser.parseFromString(
                item?.course_name,
                "text/html"
              );
              const courseName = doc.body.textContent || "";
              let obj = {
                name: item?.first_name + " " + item?.last_name,
                // "last_name": item.last_name,
                roles:
                  item?.roles === "Real Estate Agent" ||
                  item?.roles === "Participant"
                    ? "End user"
                    : item?.roles === "Manager"
                    ? "Team Manager"
                    : item?.roles === "External Instructor"
                    ? "External Trainer"
                    : item?.roles,
                email: item.email,
                office_name: item.office_name,
                user_status: item.user_status ? "Active" : "In Active",
                // user_manager_name: item.user_manager_name,
                ofc_location: item.ofc_location,
                course_name: courseName,
                profile_status: item.profile_status,
                profile_progress: item.profile_progress,
                complete_date: item.complete_date,
                asset_type: item.asset_type,
                duration: item.duration,
                course_id: item.course_id,
              };
              tempArr.push(obj);
            }

            const newThing = [];
            tempArr.map((item) => {
              newThing.push(
                _.mapKeys(item, (value, key) => {
                  switch (key) {
                    case "name":
                      return "Name";
                    // case "last_name":
                    //     return "Last Name";
                    case "roles":
                      return "Role";
                    case "email":
                      return "Email";
                    case "office_name":
                      return officeLabel;
                    // case "user_manager_name":
                    //   return "Team Manager";
                    case "user_status":
                      return "User Status";
                    case "course_name":
                      return savedFiltersDataById?.filter_content
                        ?.selectedCourseOrVideo ||
                        selectedFilters?.selectedCourseOrVideo
                        ? "Video"
                        : "Asset";
                    case "complete_date":
                      return "Completion Date & Time (ET)";
                    case "asset_type":
                      return "Asset Type";
                    case "duration":
                      return "Duration";
                    case "course_id":
                      return "Asset ID";    
                    case "profile_status":
                      return "Status";
                    case "profile_progress":
                      return "Progress %";
                    default:
                      return;
                  }
                })
              );
            });

            for (let i = 0; i < newThing.length; i++) {
              // arrayObj[i].stroke = arrayObj[i]['key1'];
              delete newThing[i].undefined;
            }

            for (let i = 0; i < data.length; i++) {
              // arrayObj[i].stroke = arrayObj[i]['key1'];
              delete data[i]._id;
            }
            // console.log('data:', data)
            // exportFromJSON({ data, fileName, exportType })

            //For mobile
            let tempObj = {
              method:
                isCompliance === "0"
                  ? "LearningProgressReport"
                  : "ComplianceReport",
              isVideos:
                savedFiltersDataById?.filter_content?.selectedCourseOrVideo ||
                selectedFilters?.selectedCourseOrVideo,
              report: newThing,
            };
            if (window.callbackHandler != undefined) {
              window.callbackHandler.postMessage(JSON.stringify(tempObj));
            } else if (window.webkit != undefined) {
              if (window.webkit.messageHandlers.callbackHandler != undefined) {
                window.webkit.messageHandlers.callbackHandler.postMessage(
                  JSON.stringify(tempObj)
                );
              }
            }

            const worksheet = XLSX.utils.json_to_sheet(newThing);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
            //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
            let fileNameNew =
              isCompliance === "0" ? "AssetProgressReport" : "ComplianceReport";
            XLSX.writeFile(workbook, fileNameNew + ".xlsx");
          }
        }
      })
      .finally((res) => {
        setIsLoading(false);
      });
  };

  //LP Managers
  useEffect(() => {
    if (!_.isEmpty(crsManagersRes)) {
      setLoadSpin(false);
      if (crsManagersRes?.status === "success") {
        let allData = crsManagersRes?.payload?.payload?.managers;
        setTotalManagers(crsManagersRes?.payload?.payload);
        let temparr = _.cloneDeep(overAllManagersData);
        if (counterForMng === 1) {
          temparr = [];
        }
        setOverAllManagersData([...temparr, ...allData]);
        dispatch(getCrsReportManagersClear());
      } else {
        let temparr = _.cloneDeep(overAllManagersData);
        setOverAllManagersData(temparr);
      }
    }
  }, [crsManagersRes]);

  useEffect(() => {
    if (!_.isEmpty(crsOfficesRes)) {
      // setLoadSpinner(false)
      setIsLoading(false);
      if (crsOfficesRes?.status === "success") {
        let allData = crsOfficesRes?.payload?.payload?.offices;
        setTotalOffices(crsOfficesRes?.payload?.payload);
        let temparr = _.cloneDeep(overAllOfficesData);
        if (counterForOffice === 1) {
          temparr = [];
        }
        setOverAllOfficesData([...temparr, ...allData]);
        dispatch(getCrsReportOfficesClear());
      } else {
        let temparr = _.cloneDeep(overAllOfficesData);
        setOverAllOfficesData(temparr);
      }
    }
  }, [crsOfficesRes]);

  return (
    <>
      <Loader start={isLoading} />
      <section className="reports-header mt-2rem">
        <div className="container-pwc">
          <div className="row">
            <div className="col-md-12 text-start mb-4">
              {JSON.parse(backbutton) ? (
                ""
              ) : (
                <button
                  type="button"
                  id="backbtnreport"
                  className="btn btn-primary-complete bckbtn m-0"
                  onClick={() => {
                    dispatch(
                      getCrsReportReaClear(),
                      getCrsReportStatsClear(),
                      getCrsReportTrendClear(),
                      getSavedFilterDataResponseClearById()
                    );
                    localStorage.removeItem("SELECTED_FILTER");
                    let obj = { message: "backButton" };
                    if (isMobile) {
                      window.parent.postMessage(
                        JSON.stringify(obj),
                        "*"
                      );
                      window.parent.postMessage(
                        JSON.stringify(obj),
                        "*"
                      );
                    } else {
                      navigate(-1);
                    }
                    if (isAndroid || isIOS) {
                      try {
                        if (window.callbackHandler != undefined) {
                          window.callbackHandler.postMessage("backButton");
                        }
                        if (window.webkit != undefined) {
                          if (
                            window.webkit.messageHandlers.callbackHandler !=
                            undefined
                          ) {
                            window.webkit.messageHandlers.callbackHandler.postMessage(
                              "backButton"
                            );
                          }
                        }
                      } catch (err) {
                        console.log("error in sending message");
                      }
                    }
                  }}
                >
                  {t("back")}
                </button>
              )}
            </div>
            <div className="col-md-12">
              <div className="reports-head-main">{t("reports")}</div>
            </div>

            <div className="col-md-12 d-flex justify-content-between dropbox-section">
              <ReportHeaderComponent
                title={
                  isCompliance === "0"
                    ? t("Asset Progress Report")
                    : t("Compliance Report")
                }
                isFilterExpand={isExpand}
                setIsFilterExpand={setIsExpand}
                exportReport={ExportToExcel}
              />
              <ReportExportButtonComponent exportReport={ExportToExcel} />
            </div>
            <div className="col-md-12">
              {isExpand && (
                <ReportFiltersComponent
                  setSelectedFilters={setSelectedFilters}
                  selectedFiltersFromDashboard={
                    savedFiltersDataById?.filter_content
                      ? savedFiltersDataById?.filter_content
                      : ""
                  }
                  setIsExpand={setIsExpand}
                  isMobile={isMobile}
                  hideOverDueStatus={true}
                  showFilters={showFilters}
                  reportType={
                    isCompliance === "0" ? "learning_progress" : "compliance"
                  }
                  setLocalFilters={setLocalFilters}
                  localFilters={localFilters}
                />
              )}
            </div>
          </div>
        </div>
      </section>

      <ReportGraphComponent
        trendYear={trendYear}
        loadChart={loaderChart}
        seriesAll={seriesOfAll}
        legendsAll={legendOfAll}
        trendValues={crsCompltTrendValues}
        listingData={courseList}
        seriesSingle={seriesOfSingle}
        legendsSingle={legendOfSingle}
        trendLoadChart={trendLoaderChart}
        filterYearData={filterYearData}
        trendFilterCourses={trendFilterCourses}
        overAllLearningPoints={overAllLearningPoints}
        trendValueSingle={crsCompltTrendValuesOfSingle}
        setYear={setTrendYear}
        setLoadChart={setLoaderChart}
        setImgLoader={setImgLoader}
        getCompletionTrend={getSingleCompletionTrend}
        filterYearDataOfSingle={filterYearDataOfSingle}
        isDetail={false}
        check={selectedFilters.check}
        courseOrVideo={
          savedFiltersDataById?.filter_content?.selectedCourseOrVideo ||
          selectedFilters.selectedCourseOrVideo
        }
      />

      {/* Offices Section */}
      <OfficesReportSection
        currentReportObj={"compliance"}
        mesg={t(
          "The offices of assigned End User will be displayed in this section."
        )}
        isMobile={isMobile}
        check={selectedFilters.check}
        overAllOfficesData={overAllOfficesData}
        setOverAllOfficesData={setOverAllOfficesData}
        setCountForOffice={setCountForOffice}
        setCounterForOffice={setCounterForOffice}
        counterForOffice={counterForOffice}
        totalOffices={totalOffices}
        cmpletionText={
          selectedFilters.check
            ? t("Courses Completed")
            : savedFiltersDataById?.filter_content?.selectedCourseOrVideo ||
              selectedFilters.selectedCourseOrVideo
            ? t("Videos Completed")
            : t("Courses Completed")
        }
        isLP={false}
        courseOrVideo={
          savedFiltersDataById?.filter_content?.selectedCourseOrVideo ||
          selectedFilters.selectedCourseOrVideo
        }
        selectedFilters={selectedFilters}
      />

      {false && (
        <ManagerReportCrs
          currentReportObj={"compliance"}
          mesg={`${t("The Team Managers that are assigned for")} ${
            savedFiltersDataById?.filter_content?.selectedCourseOrVideo ||
            selectedFilters.selectedCourseOrVideo
              ? t("videos")
              : t("courses")
          } ${t("will be shown on this section.")}`}
          isMobile={isMobile}
          check={selectedFilters.check}
          isDetail={false}
          totalManagers={totalManagers}
          setTotalManagers={setTotalManagers}
          overAllManagersData={overAllManagersData}
          setOverAllManagersData={setOverAllManagersData}
          setCountForManager={setCountForManager}
          setCounterForMng={setCounterForMng}
          counterForMng={counterForMng}
          cmpletionText={
            selectedFilters.check
              ? t("Courses Completed")
              : savedFiltersDataById?.filter_content?.selectedCourseOrVideo ||
                selectedFilters.selectedCourseOrVideo
              ? t("Videos Completed")
              : t("Courses Completed")
          }
          courseOrVideo={
            savedFiltersDataById?.filter_content?.selectedCourseOrVideo ||
            selectedFilters.selectedCourseOrVideo
          }
          selectedFilters={selectedFilters}
        />
      )}

      <REACardAreaSection
        totalREA={totalRea?.total_rea}
        extraHeader={`- ${t("Cumulative Progress of a End user")}`}
        realEstateAgent={realEstateAgent}
        isMobile={isMobile}
        actualCoursesList={actualCoursesList}
        setLoadSpin={setLoadSpin}
        loadSpin={loadSpin}
        setCount={setCount}
        counter={counter}
        setCounter={setCounter}
        check={selectedFilters.check}
        selectedFilters={selectedFilters}
        cmpletionText={
          selectedFilters.check
            ? t("Assets Completed")
            : savedFiltersDataById?.filter_content?.selectedCourseOrVideo ||
              selectedFilters.selectedCourseOrVideo
            ? t("Videos Completed")
            : t("Assets Completed")
        }
        isDetail={false}
        courseOrVideo={
          savedFiltersDataById?.filter_content?.selectedCourseOrVideo ||
          selectedFilters.selectedCourseOrVideo
        }
      />

      <div id="myOnboard" class="center_line"></div>
      <ProgressReportTableComponent
        // setSearchInput={""}
        pageSize={pageSize}
        setPageSize={setPageSize}
        getFilteredData={[]}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        isView={isView}
        statusFilterData={statusFilterData}
        setCanShow={setCanShow}
        profileReports={profileReports}
        currentTableData={currentTableData}
        type={type}
        message={
          isCompliance === "0"
            ? t("Assets that are assigned to users, will appear here.")
            : t("Courses that are assigned to users, will appear here")
        }
        isCompliance={true}
        searchTable={searchTable}
        fromPage={
          savedFiltersDataById?.filter_content?.selectedCourseOrVideo ||
          selectedFilters.selectedCourseOrVideo
            ? 4
            : 1
        } // 1=course, 2= Action Path, 3=Onboarding 4=video
        reportType={"compliance"}
        isMobile={isMobile}
        setPageNum={setPageNum}
        pageNum={pageNum}
        progressSort={progressSort}
        setProgressSort={setProgressSort}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        fetchData={fetchCrsTableReport}
      />
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={`Client is mandatory, please select first.`}
        //   ${
        //   officeLabel == "Office Name" ? "Office(s)" : officeLabel
        // }

        isConfirm={false}
        confirmId={""}
        confirmAction={""}
        isRightIcon={false}
        isMobile={isMobile}
      />
    </>
  );
};
export default ComplianceReportSection;
